import { API } from '@/api';
import { fetcher } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type PortsParams, portsResponseSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchPorts = (params: PortsParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
  const {
    country,
    limit = 10,
    offset = 0,
    portCity,
    portCode,
    portName,
    portPostal,
    portState,
    portType,
    sorting,
  } = params;

  return masterDataApi
    .get('port', {
      searchParams: toURLSearchParams({
        'InlineSearch[city]': portCity || undefined,
        'InlineSearch[code]': portCode || undefined,
        'InlineSearch[countryCode]': country,
        'InlineSearch[name]': portName || undefined,
        'InlineSearch[state]': portState || undefined,
        'InlineSearch[type]': portType || undefined,
        'InlineSearch[zip]': portPostal || undefined,
        Skip: offset,
        Sorting: sorting || 'name asc',
        Take: limit,
      }),
      signal,
    })
    .json(portsResponseSchema);
};
